import { Component, Input, ViewEncapsulation } from '@angular/core';
import { event } from 'src/app/shared/models/event';

@Component({
  selector: 'app-home-events-item',
  templateUrl: './home-events-item.component.html',
  styleUrls: ['./home-events-item.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class HomeEventsItemComponent {
  // @Input() event?: any;
  @Input() exhibition?: any;
  @Input() seminar?: any;
  @Input() lecture?: any;
  
  constructor() { }


}
 